import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/base-option/index.vue";
import CodeView from "@/views/code-view/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/code",
    component: CodeView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
